const specialViewProductKeys = {
  DEBT: 37,
  PAYMENT: 36,
  VEHICLE_REGISTRATION: 39,
  SPECIAL_RISK_OWN_DAMAGE: 14 // APV274 - Special Risk Own Damage
};

export default specialViewProductKeys;
